import { Component, ElementRef, input, output, signal, computed, viewChild } from '@angular/core';
import { OCP_ANALYTICS, TrackAction } from 'shared';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { AvatarComponent } from '../avatar/avatar.component';

@Component({
  selector: 'ocp-comment-form',
  templateUrl: './comment-form.component.html',
  styleUrl: './comment-form.component.scss',
  imports: [FormsModule, TranslatePipe, AvatarComponent, HlmButtonImports],
})
export class CommentFormComponent {
  readonly userInitials = input('');
  readonly colorSeed = input<string | undefined>(undefined);
  readonly addComment = output<string>();
  readonly commentCancel = output<void>();

  private readonly textareaRef = viewChild<ElementRef<HTMLTextAreaElement>>('textarea');

  protected readonly message = signal('');
  protected readonly canSubmit = computed(() => this.message().trim().length > 0);

  @TrackAction(OCP_ANALYTICS.ACTION.CLICK, OCP_ANALYTICS.TOKEN.TASK_DETAIL_ADD_COMMENT)
  protected onAdd(): void {
    if (!this.canSubmit()) return;
    this.addComment.emit(this.message().trim());
    this.message.set('');
    this.resetTextareaHeight();
    this.focusTextarea();
  }

  protected onCancel(): void {
    this.message.set('');
    this.resetTextareaHeight();
    this.commentCancel.emit();
    this.focusTextarea();
  }

  private resetTextareaHeight(): void {
    const el = this.textareaRef()?.nativeElement;
    if (el) el.style.height = '';
  }

  private focusTextarea(): void {
    this.textareaRef()?.nativeElement.focus();
  }

  protected onTextareaInput(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }
}
